import endpoints from "../endpoints";
import { sendRequest } from "../requests-browser";

export const fetchCloudConfigForVehicle = async (vehicleId: string) =>
  await sendRequest(endpoints.GET_VEHICLE_CLOUD_CONFIG, { path: { vehicleId } });
